import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
// Layout
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
// Pages
import { HomePage } from './pages/HomePage';
import { ProductsPage } from './pages/ProductsPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { PricingPage } from './pages/PricingPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
// Scroll to top component
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen font-sans text-slate-600 bg-white" data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Navbar data-id="element-3" />

        <main className="flex-grow" data-id="element-4">
          <AnimatePresence mode="wait" data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<HomePage data-id="element-8" />} data-id="element-7" />
              <Route path="/products" element={<ProductsPage data-id="element-10" />} data-id="element-9" />
              <Route path="/products/:productId" element={<ProductDetailPage data-id="element-12" />} data-id="element-11" />
              <Route path="/pricing" element={<PricingPage data-id="element-14" />} data-id="element-13" />
              <Route path="/contact" element={<ContactPage data-id="element-16" />} data-id="element-15" />
              <Route path="/privacy" element={<PrivacyPage data-id="element-18" />} data-id="element-17" />
              <Route path="/terms" element={<TermsPage data-id="element-20" />} data-id="element-19" />
            </Routes>
          </AnimatePresence>
        </main>

        <Footer data-id="element-21" />
      </div>
    </Router>;
}